import React from 'react';
import { Trophy, Zap, Target, Users } from 'lucide-react';
export function CompetitionDetails() {
  return <section className="py-24 bg-paper border-y border-subtle-gray" data-id="element-786">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-787">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-788">
          <div className="bg-off-white p-8 rounded-2xl border border-subtle-gray" data-id="element-789">
            <Trophy className="w-10 h-10 text-storm-red mb-6" data-id="element-790" />
            <h3 className="text-2xl text-ink mb-3" data-id="element-791">Elite Coaching</h3>
            <p className="text-gray-warm" data-id="element-792">
              Train under Chief Instructor Megan Merem, a 2x USA National
              Sparring Champion, and our dedicated coaching staff.
            </p>
          </div>
          <div className="bg-off-white p-8 rounded-2xl border border-subtle-gray" data-id="element-793">
            <Zap className="w-10 h-10 text-storm-red mb-6" data-id="element-794" />
            <h3 className="text-2xl text-ink mb-3" data-id="element-795">Advanced Sparring</h3>
            <p className="text-gray-warm" data-id="element-796">
              Learn high-level tactics, timing, distance management, and
              Olympic-style scoring techniques.
            </p>
          </div>
          <div className="bg-off-white p-8 rounded-2xl border border-subtle-gray" data-id="element-797">
            <Target className="w-10 h-10 text-storm-red mb-6" data-id="element-798" />
            <h3 className="text-2xl text-ink mb-3" data-id="element-799">Mental Toughness</h3>
            <p className="text-gray-warm" data-id="element-800">
              Develop the resilience, focus, and grit required to perform under
              pressure on the competition mat.
            </p>
          </div>
          <div className="bg-off-white p-8 rounded-2xl border border-subtle-gray" data-id="element-801">
            <Users className="w-10 h-10 text-storm-red mb-6" data-id="element-802" />
            <h3 className="text-2xl text-ink mb-3" data-id="element-803">Team Camaraderie</h3>
            <p className="text-gray-warm" data-id="element-804">
              Join a tight-knit family of dedicated athletes who push each other
              to be their absolute best.
            </p>
          </div>
        </div>
      </div>
    </section>;
}